module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZThCYMwEIVfQgdwg67QEaQbdIJKF0niIo6iG1Q6gXSCLiDpk1II/rpEoVLzQcjdEX3cJXdA5t9RSKSu68p7f1VKnegWXC/6d2PMWfL9AQlQ1HCzFA3DBf1S+AtoRGKtLacNC4nOmFlV8xhL3DE+TCaEpJT6OPMb3usNkUSXeg6zfSKBxcKp/ExY1MdsH9GjYdlbaR+vmrHWehCfxXowYf+QHpa2UxPYF3xG5FetZw/3kz2OYwch0bPaOdeGo5HCjvdqEcn+2ikLZ+FNCftgZTLb4w28Lj/RO4y8nAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/img/footer/facebook.png
// module id = 396
// module chunks = 0